export function stripHtml(html) {
  if (!html) return "";
  if (!/[<&]/.test(html)) return html;
  const div = document.createElement("div");
  div.innerHTML = html;
  return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
}

export function isHtml(s) {
  return typeof s === "string" && /<[a-z][^>]*>/i.test(s);
}

const HTML_ESCAPE = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
export function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) => HTML_ESCAPE[c]);
}

export function highlight(text, query) {
  const safe = escapeHtml(text || "");
  if (!query) return safe;
  const q = query.trim();
  if (!q) return safe;
  const pattern = q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return safe.replace(
    new RegExp(pattern, "gi"),
    (m) => `<mark class="bg-accent/25 text-foreground rounded px-0.5">${m}</mark>`
  );
}
